var exports = {
  "kL": "xa15a2ab7--533d40--container",
  "aY": "xa15a2ab7--533d40--code",
  "lZ": "xa15a2ab7--533d40--phone",
  "VH": "xa15a2ab7--533d40--preview",
  "SD": "xa15a2ab7--533d40--static-preview",
};

module.exports = exports;
